import React, { useEffect, useRef } from 'react';

const ForexCrossRatesWidget = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
  
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-forex-cross-rates.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      currencies: [
        'EUR',
        'USD',
        'JPY',
        'GBP',
        'CHF',
        'AUD',
        'CAD',
        'NZD',
        'CNY',
      ],
      width: '100%',
      height: '100%',
      locale: 'en',
      largeChartUrl: '',
    });
  
    const timeout = setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.appendChild(script);
      }
    }, 0);
  
    return () => {
      clearTimeout(timeout);
      // Refactored to avoid optional chaining
      if (containerRef.current) {
        containerRef.current.innerHTML = ''; // Cleanup on unmount
      }
    };
  }, []);

  return <div ref={containerRef} style={{ width: '100%', height: '100%' }} />;
};

export default ForexCrossRatesWidget;
